/* SWITZ — Returns & Refunds FAQ accordion.

   Plain buttons with aria-expanded and a hidden panel, so it is keyboard
   accessible and works with screen readers. Opening and closing animates the
   panel height, then the inline height is removed so the answer can reflow.
   Scoped to [data-switz-faq]: nothing else on the site is touched. */
(function () {
  'use strict';
  if (window.__switzReturnsFaq) return;
  window.__switzReturnsFaq = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function panelOf(btn) {
    var id = btn.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function open(btn) {
    var panel = panelOf(btn);
    if (!panel || btn.getAttribute('aria-expanded') === 'true') return;
    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    if (REDUCED) return;
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    panel.classList.add('is-animating');
    requestAnimationFrame(function () { panel.style.height = target + 'px'; });
    panel.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      panel.classList.remove('is-animating');
      panel.style.height = '';
    });
  }

  function close(btn) {
    var panel = panelOf(btn);
    if (!panel || btn.getAttribute('aria-expanded') !== 'true') return;
    btn.setAttribute('aria-expanded', 'false');
    if (REDUCED) { panel.hidden = true; return; }
    panel.style.height = panel.scrollHeight + 'px';
    panel.classList.add('is-animating');
    requestAnimationFrame(function () { panel.style.height = '0px'; });
    panel.addEventListener('transitionend', function done(e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      panel.classList.remove('is-animating');
      panel.style.height = '';
      panel.hidden = true;
    });
  }

  function toggles(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-switz-faq-toggle]'));
  }

  function syncAll(root) {
    var btn = root.querySelector('[data-switz-faq-all]');
    if (!btn) return;
    var items = toggles(root);
    var allOpen = items.length > 0 && items.every(function (b) { return b.getAttribute('aria-expanded') === 'true'; });
    var label = btn.querySelector('[data-switz-faq-all-label]');
    var mark = btn.querySelector('.switz-ret__expand-mark');
    btn.setAttribute('aria-expanded', allOpen ? 'true' : 'false');
    if (label) label.textContent = allOpen ? (btn.getAttribute('data-collapse-label') || 'Collapse all') : (btn.getAttribute('data-expand-label') || 'Expand all');
    if (mark) mark.textContent = allOpen ? '−' : '+';
  }

  document.addEventListener('click', function (event) {
    var root = event.target.closest('[data-switz-faq]');
    if (!root) return;

    var toggle = event.target.closest('[data-switz-faq-toggle]');
    if (toggle) {
      if (toggle.getAttribute('aria-expanded') === 'true') close(toggle);
      else open(toggle);
      syncAll(root);
      return;
    }

    var all = event.target.closest('[data-switz-faq-all]');
    if (all) {
      var items = toggles(root);
      var shouldOpen = all.getAttribute('aria-expanded') !== 'true';
      items.forEach(function (btn) { shouldOpen ? open(btn) : close(btn); });
      syncAll(root);
    }
  });

  /* Deep links. The footer's FAQ link points at /pages/returns-refunds#faq, so
     the section is given that id and scrolled to by hand — the sticky header
     would otherwise sit over the heading. */
  var ANCHOR = 'faq';
  var HEADER_GAP = 24;

  function headerOffset() {
    var header = document.querySelector('.shopify-section-group-header-group, .section-header, header.header');
    var h = header ? header.getBoundingClientRect().height : 0;
    return (h > 0 && h < 200 ? h : 0) + HEADER_GAP;
  }

  function goToFaq(smooth) {
    var root = document.getElementById(ANCHOR) || document.querySelector('[data-switz-faq]');
    if (!root) return;
    var top = root.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: smooth && !REDUCED ? 'smooth' : 'auto' });
  }

  function hashIsFaq() {
    return (window.location.hash || '').replace('#', '').toLowerCase() === ANCHOR;
  }

  function init() {
    document.querySelectorAll('[data-switz-faq]').forEach(function (root) {
      syncAll(root);
      if (!root.id) root.id = ANCHOR;
    });
    if (!hashIsFaq()) return;
    goToFaq(false);
    window.setTimeout(function () { goToFaq(false); }, 120);
    window.addEventListener('load', function () { goToFaq(false); }, { once: true });
  }

  window.addEventListener('hashchange', function () {
    if (hashIsFaq()) goToFaq(true);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
